module.exports = __webpack_public_path__ + "static/img/MA.7721c49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/listings/states/MA.jpg
// module id = wtHs
// module chunks = 0